import unified from 'unified'
import parse from 'remark-parse'
import remark2react from 'remark-react'

import { components } from './components/AppProvider/components'

const processor = unified()
  .use(parse)
  .use(remark2react, { remarkReactComponents: components })

export function markdownToReact(text) {
  return processor.processSync(text).result
}
